export const deleteNotification = (user, payload) => {
    
    return user.notifications.filter(n => n !== payload)

}